import React, { useEffect, useState } from "react";
import baseUrl from "../../config/baseUrl";
import axios from "axios";
import {
  Card,
  CardContent,
  Box,
  Typography,
  Grid,
  Button,
  CircularProgress,
  Divider,
} from "@mui/material";
import FilterCreatedOn from "../../date/FilterCreatedOn";
import FilterUpdatedOn from "../../date/FilterUpdatedOn";
import DownloadIcon from "@mui/icons-material/Download";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { useStateContext } from "../../context/ContextProvider";

const MerchantReports = ({ authCreate, authRead, authUpdate, authDelete }) => {
  const { dropdownMerchant } = useStateContext();
    
  const [createdTo, setCreatedTo] = useState("");
  const [createdFrom, setCreatedFrom] = useState("");
  const [updatedTo, setUpdatedTo] = useState("");
  const [updatedFrom, setUpdatedFrom] = useState("");
  const [loading, setLoading] = useState(false);

  const reportList = [
    {
      title: "Account Summary",
      desc: "A breakdown of gross and net sales by account.",
      rawValue: 1
    },
    {
      title: "Deposit Type Summary",
      desc: "Currency Wise Deposits.",
      rawValue: 2
    },
    {
      title: "Payout Type Summary",
      desc: "Currency Wise Deposits Payout.",
      rawValue: 3
    },
    {
      title: "Local Settlement Type Summary",
      desc: "Currency Wise Deposits Settlement.",
      rawValue: 4
    },
    {
      title: "International Settlement Type Summary",
      desc: "Currency Wise Deposits Settlement.",
      rawValue: 5
    },
    {
      title: "Dispute/Chrgeback Reports",
      desc: "View status of your Chargebacks.",
      rawValue: 6
    },
    {
      title: "Refund Reports",
      desc: "View status of your Refunds.",
      rawValue: 7
    },
  ];

  const reportApiEndpoints = {
    1: "/accountSummary",
    2: "/depositTypeReport",
    3: "/payoutTypeReport",
    4: "/settlementTypeReport",
    5: "/settlementTypeInterReport",
    6: "/chargebackTypeReport",
    7: "/refundTypeReport",
  };

  const downloadExl = (rawValue) => {
    const auth = sessionStorage.getItem("user");

    const endpoint = reportApiEndpoints[rawValue];
    if (!endpoint) {
      console.error("Invalid report type");
      return;
    }

    const values = {
      to: createdTo || undefined,
      from: createdFrom || undefined,
      To: updatedTo || undefined,
      From: updatedFrom || undefined,
      id: dropdownMerchant,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth}`,
      },
      responseType: "json",
    };

    setLoading(true);

    axios
      .post(`${baseUrl}${endpoint}`, values, config)
      .then((res) => {
        const downloadCSV = (csvString, filenameLabel) => {
          if (!csvString || csvString.trim() === "") {
            alert(`No transactions found for ${filenameLabel}`);
            return;
          }

          const blob = new Blob([csvString], { type: "text/csv;charset=utf-8" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          const timestamp = Date.now();
          a.download = `${filenameLabel}_Summary_${timestamp}.csv`;
          a.click();
          window.URL.revokeObjectURL(url);
        };

        const labelMap = {
          depositCSV: "Deposit",
          payoutCSV: "Payout",
          localCSV: "Local",
          internationalCSV: "International",
          chargebackCSV: "Chargeback",
          refundCSV: "Refund",
        };

        Object.keys(res.data).forEach((key) => {
          if (labelMap[key]) {
            downloadCSV(res.data[key], labelMap[key]);
          }
        });
      })
      .catch((err) => {
        console.error(err);
        alert(err?.response?.data?.message || "Download failed");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    
  }, [createdTo, createdFrom, updatedTo, updatedFrom, dropdownMerchant]);

  return (
    <>
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <CircularProgress size={60} thickness={5} style={{ color: "#fff" }} />
          <Typography mt={2} variant="h6" color="white">
            Downloading report...
          </Typography>
        </Box>
      )}
      {/* <Box>
        <Card elevation={4} sx={{ borderRadius: "16px", p: 2 }}>
          <CardContent>
            <Grid container spacing={2} justifyContent="center" mb={4}>
              <Grid item xs={12} sm={8}>
                  <Typography
                      variant="h4"
                      sx={{
                          fontWeight: 700,
                          textAlign: "center",
                          mb: 4,
                          color: "#1976d2",
                          letterSpacing: "1px",
                      }}
                  >
                    MERCHANT REPORTS
                  </Typography>
              </Grid>
              <Grid item xs={6} sm={2}>
                <FilterCreatedOn
                  setCreatedTo={setCreatedTo}
                  setCreatedFrom={setCreatedFrom}
                />
              </Grid>
              <Grid item xs={6} sm={2}>
                <FilterUpdatedOn
                  setUpdatedTo={setUpdatedTo}
                  setUpdatedFrom={setUpdatedFrom}
                />
              </Grid>
            </Grid>

            {reportList.map((report, index) => (
              <Card
                key={index}
                elevation={1}
                sx={{
                  borderRadius: "12px",
                  mb: 3,
                  background: "#f9f9f9",
                  p: 2,
                  transition: "0.3s",
                  "&:hover": {
                    boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                    backgroundColor: "#f1faff",
                  },
                }}
              >
                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Grid item xs={12} sm={8}>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {report.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {report.desc}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    textAlign="right"
                    mt={{ xs: 2, sm: 0 }}
                  >
                    <Button
                      variant="contained"
                      endIcon={<DownloadIcon />}
                      onClick={() => downloadExl(report.rawValue)}
                      sx={{
                        borderRadius: "30px",
                        backgroundColor: "#1976d2",
                        textTransform: "none",
                        fontWeight: "bold",
                        padding: "10px 16px",
                        "&:hover": {
                          backgroundColor: "#125ea3",
                        },
                      }}
                    >
                      Download Report
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            ))}
          </CardContent>
        </Card>
      </Box> */}
      <Box>
      <Card elevation={4} sx={{ borderRadius: "16px", p: 3 }}>
        <CardContent>
          <Grid container spacing={2} justifyContent="center" mb={4}>
            <Grid item xs={12} sm={4} md={4}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  fontWeight: 'bold',
                  color: '#1976d2',
                  fontSize: '1.5rem',
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                }}
              >
                MERCHANT REPORTS
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4} md={4}>
              <FilterCreatedOn
                setCreatedTo={setCreatedTo}
                setCreatedFrom={setCreatedFrom}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={4}>
              <FilterUpdatedOn
                setUpdatedTo={setUpdatedTo}
                setUpdatedFrom={setUpdatedFrom}
              />
            </Grid>
          </Grid>

          {loading && (
            <Box display="flex" justifyContent="center" my={5}>
              <CircularProgress color="primary" size={40} />
            </Box>
          )}

          {reportList.map((report, index) => (
            <React.Fragment key={index}>
              <Card
                elevation={1}
                sx={{
                  borderRadius: "12px",
                  p: 2,
                  mb: 2,
                  backgroundColor: "#fff",
                  border: "1px solid #e0e0e0",
                  transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                  },
                }}
              >
                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Grid item xs={12} sm={8}>
                    <Box display="flex" alignItems="center">
                      <AssessmentIcon sx={{ color: "#1976d2", fontSize: 32, mr: 2 }} />
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          {report.title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {report.desc}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    textAlign="right"
                    mt={{ xs: 2, sm: 0 }}
                  >
                    <Button
                      variant="contained"
                      endIcon={<DownloadIcon />}
                      onClick={() => downloadExl(report.rawValue)}
                      sx={{
                        borderRadius: "25px",
                        backgroundColor: "#1976d2",
                        textTransform: "capitalize",
                        fontWeight: 600,
                        px: 3,
                        py: 1.2,
                        fontSize: "0.95rem",
                        "&:hover": {
                          backgroundColor: "#125ea3",
                        },
                      }}
                    >
                      Download
                    </Button>
                  </Grid>
                </Grid>
              </Card>
              {index !== reportList.length - 1 && <Divider sx={{ my: 1 }} />}
            </React.Fragment>
          ))}
        </CardContent>
      </Card>
    </Box>
    </>
  );
};

export default MerchantReports;
